import React from "react";
import Skeleton from "react-loading-skeleton";

// A placeholder shaped like one reporter row — the 45px avatar plus the name and title lines — so the
// roster does not reflow when the real rows land. It renders one row's content and nothing else: the
// list that shows it owns the <ul>, the <li> and the divider, and the two places it appears wrap it
// differently (inside the roster list, and inside the scroll trigger's own list).
function MediaOutletReporterRowSkeleton() {
  return (
    <div className="d-flex align-items-center">
      <div className="flex-shrink-0 me-2">
        <Skeleton circle height={45} width={45} />
      </div>
      <div className="flex-grow-1">
        <Skeleton height={16} width="60%" />
        <Skeleton height={12} width="40%" />
      </div>
    </div>
  );
}

export default MediaOutletReporterRowSkeleton;
